
import { Component, Ref, Vue } from 'vue-property-decorator';
import ErrorService from '@/utils/ErrorService';

// API
import { getCity } from '@/utils/api/Cities';

// Components
import VAdministrationMain from '@/components/Administration/VAdministrationMain.vue';
import VAdministrationHeader from '@/components/Administration/VAdministrationHeader.vue';
import VPageTitle from '@/components/Administration/VPageTitle.vue';
import VAdministrationWidget from '@/components/Administration/VAdministrationWidget.vue';
import VAdministrationCityForm from '@/components/Administration/VAdministrationCityForm.vue';

import VBreadcrumbs from '@/components/VBreadcrumbs.vue';
import VPoppedAlert from '@/components/VPoppedAlert.vue';

// Interfaces
import City from '@/ship/Models/City';
import { AxiosError } from 'axios';

@Component({
    components: {
        VAdministrationMain,
        VAdministrationHeader,
        VPageTitle,
        VAdministrationWidget,
        VAdministrationCityForm,

        VBreadcrumbs,
        VPoppedAlert,
    },
})
export default class CityEditPage extends Vue {
    @Ref() poppedAlert!: VPoppedAlert;

    public currentCity: City | null = null;

    get cityId(): number {
        return +this.$route.params.id;
    }

    async showSuccess() {
        this.poppedAlert?.show(this.$t('dataSavedSuccessfully'));
    }

    async created() {
        const response = await getCity(this.cityId).catch((error) => {
            if ((error as AxiosError).response?.status === 404) this.$router.push({ name: 'error.404' });
            else ErrorService.handleApiError(error);
        });

        if (response) this.currentCity = response.data.data;
    }
}
